import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import SrDarkModal from 'client/components/SrDarkModal';
import SrModalContent from 'client/components/SrModalContent';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREEN,
  SR_BUTTON_HEIGHT_MEDIUM,
} from 'client/components/SrButton/SrButton';
import SrBox from 'client/components/SrBox';

const SrSupraShowingTourFeedbackModal = ({ supraShowing, onClose, onSubmit }) => (
  <SrDarkModal onClose={onClose}>
    <SrModalContent width={690} dynamicHeight>
      <Formik
        enableReinitialize
        initialValues={{ tourFeedback: supraShowing.tourFeedback }}
        onSubmit={onSubmit}
        render={(formikBag) => (
          <Form>
            <SrFormikField
              formikBag={formikBag}
              formField={{
                id: 'tourFeedback',
                title: 'Write Tour Feedback',
                type: 'long_text',
              }}
              theme={SR_FIELD_THEME_ADOBE}
              margin="0"
            />
            <SrBox marginTop="15px" />
            <SrButton
              theme={SR_BUTTON_THEME_ADOBE_GREEN}
              minWidth="100%"
              heightType={SR_BUTTON_HEIGHT_MEDIUM}
              type="submit"
              hasBoxShadow
            >
              Submit Feedback
            </SrButton>
          </Form>
        )}
      />
    </SrModalContent>
  </SrDarkModal>
);

SrSupraShowingTourFeedbackModal.propTypes = {
  supraShowing: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

SrSupraShowingTourFeedbackModal.displayName = 'SrSupraShowingTourFeedbackModal';

export default SrSupraShowingTourFeedbackModal;
